import { makeAutoObservable, runInAction } from 'mobx';
import { superadminListClients } from '@pro-sto/api-client';
import type { SuperadminClientListItemDto } from '@pro-sto/api-client';
import { toastStore } from './ToastStore';

export type ClientItem = SuperadminClientListItemDto;

export class ClientsStore {
  clients: ClientItem[] = [];
  total = 0;
  page = 1;
  limit = 20;
  search = '';
  isLoading = false;
  isLoadingMore = false;

  constructor() {
    makeAutoObservable(this);
  }

  get hasMore(): boolean {
    return this.clients.length < this.total;
  }

  setSearch = (value: string) => {
    this.search = value;
    this.loadClients();
  };

  /** Initial load / search reset — replaces the list */
  loadClients = async () => {
    this.isLoading = true;
    try {
      const response = await superadminListClients({
        page: 1,
        limit: this.limit,
        q: this.search || undefined,
      });
      runInAction(() => {
        this.clients = response.data ?? [];
        this.total = response.meta.total ?? 0;
        this.page = 1;
        this.isLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.isLoading = false;
      });
      toastStore.showError('Не удалось загрузить список клиентов');
      console.error('Failed to load clients:', error);
    }
  };

  /** Append next page — used by infinite scroll */
  loadMore = async () => {
    if (this.isLoadingMore || !this.hasMore) return;
    this.isLoadingMore = true;
    const nextPage = this.page + 1;
    try {
      const response = await superadminListClients({
        page: nextPage,
        limit: this.limit,
        q: this.search || undefined,
      });
      runInAction(() => {
        this.clients = [...this.clients, ...(response.data ?? [])];
        this.total = response.meta.total ?? 0;
        this.page = nextPage;
        this.isLoadingMore = false;
      });
    } catch (error) {
      runInAction(() => {
        this.isLoadingMore = false;
      });
      toastStore.showError('Не удалось загрузить список клиентов');
      console.error('Failed to load more clients:', error);
    }
  };
}

export const clientsStore = new ClientsStore();
